module.exports = __webpack_public_path__ + "img/SSH-Key-136px.8311f89.png";